// extracted by mini-css-extract-plugin
export default {"sidebar":"ReportsSidebar_sidebar__GNTgX","navList":"ReportsSidebar_navList__SH0NW","navItem":"ReportsSidebar_navItem__GxmeX","navItemActive":"ReportsSidebar_navItemActive__6gL+u"};